import * as React from 'react'
import { api } from '../lib/api'
import Card from '@mui/joy/Card'
import Chip from '@mui/joy/Chip'
export default function MyApplications() {
  const [rows, setRows] = React.useState<any[]>([])
  React.useEffect(() => {
    api('/applications/mine').then(setRows)
  }, [])
  return (
    <div className="max-w-6xl mx-auto p-6 space-y-3">
      <h2 className="text-2xl font-semibold">My Applications</h2>
      {rows.map((r) => (
        <Card key={r.id} variant="outlined" className="flex items-center justify-between">
          <div>
            <div className="font-semibold">{r.title}</div>
            <div className="text-sm opacity-70">
              {r.companyName} • Job is {r.jobStatus}
            </div>
            <Chip size="sm" variant="soft" className="mt-2">
              {r.status}
            </Chip>
          </div>
          <a className="underline" href={'/applications/' + r.id}>
            Open
          </a>
        </Card>
      ))}
    </div>
  )
}
